module.exports = "<div class=\"row\">\n    <div class=\"col-lg-12\">\n        <div class=\"view-header\">\n            <div class=\"header-icon\">\n                <i [ngClass]=\"icon\"></i>\n            </div>\n            <div class=\"header-title\">\n                <h3>{{ activePageTitle }}</h3>\n            </div>\n        </div>\n        <hr>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/baContentTop/baContentTop.html
// module id = ../../../../../src/app/theme/components/baContentTop/baContentTop.html
// module chunks = 14